var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChartLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2CBE96",
  fillRule: "evenodd",
  d: "M28.47 16.797c0 5.773-7.103 10.061-10.491 11.783a3.83 3.83 0 0 1-3.482.003C11.112 26.863 4 22.563 4 16.797V8.459a1.548 1.548 0 0 1 1.38-1.517 17.424 17.424 0 0 0 8.981-3.321 3.139 3.139 0 0 1 3.748 0 17.424 17.424 0 0 0 8.982 3.321 1.548 1.548 0 0 1 1.38 1.517v8.338Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M20.714 15.072a.929.929 0 0 0-.928-.93h-1.857v-1.856a.929.929 0 0 0-.929-.929h-1.857a.929.929 0 0 0-.929.929v1.857h-1.857a.929.929 0 0 0-.928.928v1.858c0 .512.415.928.928.928h1.857v1.857c0 .513.416.929.929.929H17a.929.929 0 0 0 .929-.929v-1.857h1.857a.929.929 0 0 0 .928-.928v-1.857Z",
  clipRule: "evenodd"
})));
export default SvgChartLine;